<div class="feature-error-banner" role="alert" *ngIf="featureProblem">
  <i class="material-icons">info</i>
  <span>{{ featureProblem.detail }}</span>
  <button type="button" aria-label="Dismiss message" (click)="dismissFeatureError()">×</button>
</div>
<router-outlet />
<app-confirm-dialog
  *ngIf="confirmationRequest$ | async as request"
  [title]="request.title"
  [message]="request.message"
  [confirmLabel]="request.confirmLabel"
  [cancelLabel]="request.cancelLabel"
  [tone]="request.tone"
  (confirmed)="confirmations.accept()"
  (cancelled)="confirmations.cancel()">
</app-confirm-dialog>
